<!--
  - Copyright (c) 2021 LNBIG.com
  - All rights reserved.
  -->

<template>
  <v-container fluid v-if="currentProgressPosition !== null">
    <one-step-group
      :value="currentProgressPosition"
      :active="active"
      :progress="progress"
    >
      <!--      # 0 - prepayment -->
      <one-step-item title="Prepaiment">
        <template #subtitle
          >This is the HODL invoice
          <strong
            >funds will be taken only after successful channel opening
            service</strong
          ></template
        >
        <v-row justify="center">
          <v-col cols="auto">
            <v-card>
              <v-card-title>HODL Invoice</v-card-title>
              <v-card-text>
                <prepayment
                  v-if="prepayment.invoice"
                  v-bind="prepayment"
                  v-on:qr-code-tapped="warningReturn = true"
                ></prepayment>
              </v-card-text>
              <v-card-actions>
                <v-btn text @click="copy('Invoice', prepayment.invoice)"
                  >Copy</v-btn
                >
                <v-btn text @click="warningReturn = true">Open wallet</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <v-dialog
          v-model="warningReturn"
          :width="500"
        >
          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              Don't forget to come back here
            </v-card-title>

            <v-card-text class="my-3">
              Your wallet will open now. Please switch back to the browser after sending the payment and continue the following steps!
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="warningReturn = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="primary"
                text
                @click="openWallet"
              >
                OK, I'll be back
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </one-step-item>
      <!--      # 1 - LNURL or node info filling -->
      <one-step-item
        title="LNURL / Your node info"
        subtitle="Scan the LNURL with your node wallet to open the channel, or enter the Node ID of the node to receive the channel"
        :focus="focusNodeInfo"
        :blur="blurNodeInfo"
      >
        <template #default>
          <v-container fluid>
            <v-row>
              <v-col cols="12" lg="4">
                <v-row justify="center">
                  <v-col cols="auto">
                    <v-card>
                      <v-card-title
                        >LNURL ({{ openChannelInfo.attemptNumber }}/{{
                          openChannelInfo.maxAttempts
                        }})
                      </v-card-title>
                      <v-card-text>
                        <lnurl v-bind="openChannelInfo" />
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                          text
                          @click="copy('LNURL', openChannelInfo.lnurl)"
                          >Copy</v-btn
                        >
                        <v-btn text @click="openLnurlLink">Open wallet</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" lg="1">
                <v-divider :vertical="$vuetify.breakpoint.lgAndUp"></v-divider>
              </v-col>
              <v-col cols="12" lg="7">
                <v-row>
                  <v-col cols="12" v-if="qrcodeScanner" class="text-center">
                    <full-screen-qr-code-scanner @decode="onQRCodeScanning" />
                  </v-col>
                  <v-col cols="12">
                    <v-row justify="center">
                      <v-col>
                        <v-card>
                          <v-card-title
                            >NODE INFO ({{ openChannelInfo.attemptNumber }}/{{
                              openChannelInfo.maxAttempts
                            }})
                          </v-card-title>
                          <v-card-text>
                            <v-textarea
                              ref="nodeInfoField"
                              label="Node info in any format (can be found by inserting invoice from the target node too)"
                              auto-grow
                              rows="4"
                              outlined
                              :prepend-icon="
                                qrcodeScanner
                                  ? 'mdi-qrcode-remove'
                                  : 'mdi-qrcode-scan'
                              "
                              @click:prepend.stop="
                                qrcodeScanner = !qrcodeScanner
                              "
                              @input="updateAnyNodeInfo($event)"
                              clearable
                              @click:clear="updateAnyNodeInfo(null)"
                              :rules="[
                                openChannelInfo.connectMethod.checkStatus ===
                                null
                                  ? true
                                  : openChannelInfo.connectMethod.checkStatus,
                              ]"
                              :value="openChannelInfo.connectMethod.anyNodeInfo"
                            >
                            </v-textarea>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              @click="
                                connectMethodCommand({
                                  command: 'checkAnyNodeInfo',
                                })
                              "
                              :loading="openChannelInfo.connectMethod.checking"
                              :disabled="openChannelInfo.connectMethod.checking"
                              color="primary"
                              class="ma-2 white--text"
                            >
                              {{
                                openChannelInfo.connectMethod.checkStatus ===
                                null
                                  ? "Check it"
                                  : openChannelInfo.connectMethod
                                      .checkStatus === true
                                  ? "Checked"
                                  : "Not valid"
                              }}
                              <v-icon
                                dark
                                v-text="
                                  openChannelInfo.connectMethod.checkStatus ===
                                  null
                                    ? 'mdi-cloud-search-outline'
                                    : openChannelInfo.connectMethod
                                        .checkStatus === true
                                    ? 'mdi-check'
                                    : 'mdi-alert-octagram-outline'
                                "
                              ></v-icon>
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row justify="center"> </v-row>
          </v-container>
        </template>
        <template #placeholder>
          <v-container fluid>
            <v-row>
              <v-col class="text-start"
                >Please pay above the HODL invoice.</v-col
              >
            </v-row>
          </v-container>
        </template>
      </one-step-item>
      <!--      # 2 - checking node info received from server and open button if we have connect already -->
      <one-step-item
        title="Please check the node info"
        subtitle="You are here because you filled the Node ID. Please confirm the node and channel type below are correct, and continue for LNBIG to open the channel."
      >
        <template #default>
          <!--          TODO Сделать в store признак, что канал был открыт по lnurl,
                          а также помещать туда node id, с которым был открыт канал-->
          <v-container fluid>
            <v-row>
              <v-col cols="12" md="4" class="text-left text-md-right text-h6">
                Node ID
              </v-col>
              <v-col
                cols="12"
                md="8"
                class="text-left text-truncate text-no-wrap"
              >
                {{ openChannelInfo.connectMethod.nodeId }}
              </v-col>
            </v-row>
            <v-row v-if="openChannelInfo.connectMethod.aliasNode">
              <v-col cols="12" md="4" class="text-left text-md-right text-h6">
                Alias
              </v-col>
              <v-col
                cols="12"
                md="8"
                class="text-left text-truncate text-no-wrap"
              >
                {{ openChannelInfo.connectMethod.aliasNode }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" md="4" class="text-left text-md-right text-h6">
                Type of channel
              </v-col>
              <v-col cols="12" md="8" class="text-left">
                <v-switch
                  v-model="publicChannelSwitch"
                  label="Public channel"
                />
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col cols="12" md="4" class="text-left text-md-right text-h6">
                Will be opened
              </v-col>
              <v-col
                cols="12"
                md="8"
                :class="{
                  'text-left': true,
                  'text-h6': true,
                  'red--text': !publicChannelSwitch,
                  'indigo--text': publicChannelSwitch,
                }"
              >
                {{
                  "The " +
                  (publicChannelSwitch ? "Public" : "Private") +
                  " channel"
                }}
              </v-col>
            </v-row>
            <v-row justify="space-around">
              <v-col>
                <v-btn color="success" @click="userCheckedNodeInfo"
                  >All right!</v-btn
                >
              </v-col>
              <v-col>
                <v-btn dark color="grey" @click="fixOtherNode">To fix it</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <template #placeholder>
          <v-container fluid>
            <v-row>
              <v-col class="text-start"
                >This the stage for Node ID method. The LNBiG will try to find
                in the Lightning Network your node and asked your confirmation
                after your check.
              </v-col>
            </v-row>
          </v-container>
        </template>
      </one-step-item>
      <!--      # 3 - button to open channel or connect instruction -->
      <one-step-item
        title="Connection procedure"
        subtitle="The Last Mile before opening channel"
      >
        <template #default>
          <div
            key="ifConnected"
            v-if="openChannelInfo.connectMethod.clientConnected === true"
          >
            You can start the channel opening right now! Only please push the
            button here or confirm your node info above in previous stage.
            <v-btn
              @click="connectMethodCommand({ command: 'openingChannelDesire' })"
              :disabled="openChannelInfo.connectMethod.openingChannel"
              :loading="openChannelInfo.connectMethod.openingChannel"
              >Open Channel
            </v-btn>
          </div>
          <div
            key="ifNotConnected"
            v-else-if="openChannelInfo.connectMethod.clientConnected === false"
          >
            <v-alert dense border="left" type="warning"
              >Your action required!<br />
              Please connect to the LNBIG node (listed below) as a peer.
              You can use the green buttons for copying (the area is scrollable). As
              soon as you connect you will immediately get the inbound
              channel!
            </v-alert>
            <v-simple-table>
              <template #default>
                <thead>
                  <tr>
                    <th class="text-left">What</th>
                    <th class="text-left">Copy</th>
                    <th class="text-left">Value</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Node ID</td>
                    <td>
                      <v-btn
                        color="green"
                        dark
                        @click="
                          copy(
                            'Node ID',
                            openChannelInfo.connectMethod.nodeIdForConnect
                          )
                        "
                      >
                        Copy
                      </v-btn>
                    </td>
                    <td align="left">
                      {{ openChannelInfo.connectMethod.nodeIdForConnect }}
                    </td>
                  </tr>
                  <tr>
                    <td>Host</td>
                    <td>
                      <v-btn
                        color="green"
                        dark
                        @click="
                          copy(
                            'Host',
                            openChannelInfo.connectMethod.hostForConnect
                          )
                        "
                        >Copy
                      </v-btn>
                    </td>
                    <td align="left">
                      {{ openChannelInfo.connectMethod.hostForConnect }}
                    </td>
                  </tr>
                  <tr>
                    <td>Port</td>
                    <td>
                      <v-btn
                        color="green"
                        dark
                        @click="
                          copy(
                            'Port',
                            openChannelInfo.connectMethod.portForConnect
                          )
                        "
                        >Copy
                      </v-btn>
                    </td>
                    <td align="left">
                      {{ openChannelInfo.connectMethod.portForConnect }}
                    </td>
                  </tr>
                  <tr>
                    <td>Host:Port</td>
                    <td>
                      <v-btn
                        color="green"
                        dark
                        @click="
                          copy(
                            'Host:Port',
                            openChannelInfo.connectMethod.hostForConnect +
                              ':' +
                              openChannelInfo.connectMethod.portForConnect
                          )
                        "
                      >
                        Copy
                      </v-btn>
                    </td>
                    <td align="left">
                      {{
                        openChannelInfo.connectMethod.hostForConnect +
                        ":" +
                        openChannelInfo.connectMethod.portForConnect
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>NodeID@Host:Port</td>
                    <td>
                      <v-btn
                        color="green"
                        dark
                        @click="
                          copy(
                            'NodeID@Host:Port',
                            openChannelInfo.connectMethod.nodeIdForConnect +
                              '@' +
                              openChannelInfo.connectMethod.hostForConnect +
                              ':' +
                              openChannelInfo.connectMethod.portForConnect
                          )
                        "
                      >
                        Copy
                      </v-btn>
                    </td>
                    <td align="left">
                      {{
                        openChannelInfo.connectMethod.nodeIdForConnect +
                        "@" +
                        openChannelInfo.connectMethod.hostForConnect +
                        ":" +
                        openChannelInfo.connectMethod.portForConnect
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td>Electrum console</td>
                    <td>
                      <v-btn
                        color="green"
                        dark
                        @click="
                          copy('Electrum console', electrumConsoleCommand)
                        "
                      >
                        Copy
                      </v-btn>
                    </td>
                    <td align="left">
                      {{ electrumConsoleCommand }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-row justify="center">
              <v-col cols="12"
                >Anyway have problems with connecting? Then try our other
                node!</v-col
              >
              <v-col>
                <v-btn
                  color="red"
                  dark
                  :loading="regenerateLoading"
                  @click="regenerateClick"
                >
                  <v-icon class="mr-4">mdi-reload</v-icon>
                  Regenerate
                </v-btn>
              </v-col>
            </v-row>
          </div>
          <div key="ifElse" v-else>Please wait channel...</div>
        </template>
        <template #placeholder>
          <v-container fluid>
            <v-row>
              <v-col class="text-start"
                >If the LNBiG will not be able to connect to your node it will
                ask you to make connect to certain its node
              </v-col>
            </v-row>
          </v-container>
        </template>
      </one-step-item>
      <!--      # 4 - final stage - "Happy end" -->
      <one-step-item title="Happy end">
        <template #default>
          <final-good-status
            :channel-point="openChannelInfo.channelPoint"
            @restart-process="restartOpenChannel()"
          ></final-good-status>
        </template>
        <template #placeholder>
          <v-container fluid>
            <v-row>
              <v-col class="text-start">You will get the inbound channel</v-col>
            </v-row>
          </v-container>
        </template>
      </one-step-item>
    </one-step-group>
    <v-fab-transition>
      <share-button
        v-show="fabShareButton"
        :page-url="currentUrl"
      ></share-button>
    </v-fab-transition>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Countdown from "@/components/Mixin/Countdown";
import dbg from "debug";
import OneStepItem from "@/components/OneStepItem";
import OneStepGroup from "@/components/OneStepGroup";
import Prepayment from "./Prepayment";
import Lnurl from "@/components/Lnurl";
import FinalGoodStatus from "@/components/FinalGoodStatus";
import FullScreenQrCodeScanner from "@/components/FullScreenQrCodeScanner";
import Copy from "@/components/Mixin/Copy";
import { decode as invoiceDecode } from "@node-lightning/invoice";

const debug = dbg("lnbig:connect-method");

export default {
  name: "ConnectMethod",
  components: {
    FullScreenQrCodeScanner,
    OneStepGroup,
    OneStepItem,
    FinalGoodStatus,
    Prepayment,
    Lnurl,
  },
  mixins: [Countdown, Copy],
  props: {
    active: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qrcodeScanner: false,
      regenerateLoading: false,
      fabShareButton: false,
      currentUrl: null,
      warningReturn: false,
    };
  },
  mounted() {
    console.log("connect method mounted");
    this.startCountdown();
    this.$watch(
      function () {
        return (
          (typeof this.openChannelInfo.connectMethod.checkStatus === "string"
            ? this.openChannelInfo.connectMethod.checkStatus
            : null) ||
          this.openChannelInfo.error ||
          this.prepayment.error
        );
      },
      (newVal) => {
        if (typeof newVal === "string" && newVal.length > 0)
          this.showSnackError(newVal);
      }
    );
  },
  watch: {
    currentProgressPosition(newValue, oldValue) {
      this.regenerateLoading = false;
      if (newValue !== null)
        this.$nextTick(() => {
          this.fabShareButton = newValue !== null;
        });
      else this.fabShareButton = false;

      this.currentUrl = window.location.toString();
    },
  },
  computed: {
    ...mapState("openChannel", ["openChannelInfo", "prepayment"]),
    currentProgressPosition() {
      if (this.prepayment.prepaid) {
        if (!this.openChannelInfo.opened) {
          if (this.openChannelInfo.connectMethod.checkStatus !== true) return 1;
          else
            return this.openChannelInfo.connectMethod.userCheckedTheNodeInfo
              ? 3
              : 2;
        } else return 4;
      } else if (this.prepayment.invoice) {
        return 0;
      } else return null;
    },
    publicChannelSwitch: {
      get() {
        return this.openChannelInfo.connectMethod.userPublicDecision === null
          ? this.openChannelInfo.connectMethod.predictPublic
          : this.openChannelInfo.connectMethod.userPublicDecision;
      },
      set(payload) {
        this.connectMethodCommand({
          command: "setUserPublicDecision",
          payload,
        });
      },
    },
    compCountdown() {
      return this.currentProgressPosition === 0
        ? this.prepayment.countdown
        : this.openChannelInfo.countdown;
    },
    compExpires() {
      return this.currentProgressPosition === 0
        ? this.prepayment.expires
        : this.openChannelInfo.expires;
    },
    startTimeForCountdown() {
      return this.currentProgressPosition === 0
        ? this.$store.state.openChannel.startTimeForPrepaymentCountdown
        : this.$store.state.openChannel.startTimeForLnurlCountdown;
    },
    electrumConsoleCommand() {
      return (
        "add_peer('" +
        this.openChannelInfo.connectMethod.nodeIdForConnect +
        "@" +
        this.openChannelInfo.connectMethod.hostForConnect +
        ":" +
        this.openChannelInfo.connectMethod.portForConnect +
        "')"
      );
    },
  },
  methods: {
    updateAnyNodeInfo(value) {
      if (/lnbc/i.test(value)) {
        let res =
          /.*?(lnbc\d+[munp]1[qpzry9x8gf2tvdw0s3jn54khce6mua7l]+)/i.exec(value);

        if (res !== null && res[1] !== "") {
          debug("looks like the invoice: %s", res[1]);
          try {
            let inv = invoiceDecode(res[1]);
            debug("decoded invoice is: %o", inv);
            value = inv.pubkey.toString("hex");
          } catch (e) {
            debug("error in invoice decoding: %o", e);
            value =
              "You have entered the lightning invoice but it is not decoded - may be corrupted!";
          }
        }
      }
      debug("updateAnyNodeInfo, value: %o", value);
      this.connectMethodCommand({
        command: "changeAnyNodeInfo",
        payload: value,
      });
      // Повторяем здесь то, что посылает сервер другим клиентам с той же сессией (но не посылает нам - тому, кто генерирует события)
      this.$store.commit("openChannel/cmdSetConnectMethod", {
        anyNodeInfo: value,
        userPublicDecision: null,
        checkStatus: null,
        userCheckedTheNodeInfo: false,
      });
    },
    ...mapActions("openChannel", [
      "connectMethodCommand",
      "restartOpenChannel",
    ]),
    userCheckedNodeInfo() {
      this.connectMethodCommand({ command: "userCheckedNodeInfo" });
      if (this.openChannelInfo.connectMethod.clientConnected === true)
        this.connectMethodCommand({ command: "openingChannelDesire" });
    },
    fixOtherNode() {
      this.updateAnyNodeInfo(null);
    },
    focusNodeInfo() {
      this.$refs.nodeInfoField && this.$refs.nodeInfoField.focus();
    },
    blurNodeInfo() {
      this.$refs.nodeInfoField && this.$refs.nodeInfoField.blur();
    },
    async onQRCodeScanning(str) {
      this.updateAnyNodeInfo(str);
      await this.connectMethodCommand({ command: "checkAnyNodeInfo" });
      this.qrcodeScanner = false;
    },

    showSnackError(str) {
      if (this.$snackBar) {
        this.$snackBar.color = "error";
        this.$snackBar.timeout = 3000;
        this.$snackBar.text = str;
        this.$snackBar.show = true;
      }
    },

    regenerateClick() {
      this.regenerateLoading = true;
      this.connectMethodCommand({ command: "pleaseRegenerateLnurl" });
    },

    openPrepaymentLink() {
      window.open(
        `lightning:${this.prepayment.invoice}`,
        "_blank"
      );
    },

    openLnurlLink() {
      window.open(
        `lightning:${this.openChannelInfo.lnurl}`.toUpperCase(),
        "_blank"
      );
    },
    openWallet() {
      this.warningReturn = false
      this.openPrepaymentLink()
    }
  },
};
</script>

<style></style>
